export default "__VITE_ASSET__CL$uN_eC__"